import { BrandLogo } from '../../../../../_UI/BrandLogo';
import '../_Styles/Auth.css';

/*
    AUTH MINIMAL
    ------------
    El login y el segundo factor comparten un shell deliberadamente simple:
    logo + tarjeta centrada. No hay columna de marketing, features ni textos
    decorativos alrededor del formulario.
*/
export const AuthShell = ({ children }) => (
    <div className="PBAUTH__shell">
        <main className="PBAUTH__minimal">
            <a className="PBAUTH__brand" href="/" aria-label="Volver al portfolio">
                <BrandLogo slot="HEADER_PUBLIC" className="PBAUTH__brand_logo" />
            </a>

            <section className="PBAUTH__form_stage" aria-label="Acceso privado">
                {children}
            </section>
        </main>
    </div>
);
